import React from 'react'
import { Grid, Typography, Container, makeStyles } from '@material-ui/core'
import withTranslate from 'react-redux-multilingual/lib/withTranslate'
import { displayNumber } from '../../../../../../helpers/utils'

const ParentScore = ({ parentScores, translate }) => {
  const classes = useStyles()

  if (!parentScores?.length) {
    return null
  }
  const header = (
    <Grid container item spacing={1}>
      <Grid item xs={6}>
        <Typography classes={classes} align={'left'} variant={'subtitle1'}>
          {translate('accomplishmentFrom')}
        </Typography>
      </Grid>
      <Grid item xs={3}>
        <Typography classes={classes} align={'right'} variant={'subtitle1'}>
          {translate('weightScore')}
        </Typography>
      </Grid>
      <Grid item xs={3}>
        <Typography classes={classes} align={'right'} variant={'subtitle1'}>
          {translate('score')}
        </Typography>
      </Grid>
    </Grid>
  )
  const data = parentScores.map(item => {
    return (
      <Grid container item spacing={1} key={item.parent_name}>
        <Grid item xs={6}>
          <Typography classes={classes} align={'left'} variant={'subtitle2'}>
            - {item.parent_name}
          </Typography>
        </Grid>
        <Grid item xs={3}>
          <Typography classes={classes} align={'right'} variant={'subtitle2'}>
            {displayNumber(item.weight_score, 2)} / 100.00
          </Typography>
        </Grid>
        <Grid item xs={3}>
          <Typography classes={classes} align={'right'} variant={'subtitle2'}>
            {displayNumber(item.score, 2)} / 5.00
          </Typography>
        </Grid>
      </Grid>
    )
  })
  return (
    <Container style={{ padding: 16 }}>
      <Grid container spacing={1} direction={'column'}>
        {header}
        {data}
      </Grid>
    </Container>
  )
}

const useStyles = makeStyles(theme => ({
  subtitle1: {
    fontWeight: 600
  },
  subtitle2: {
    fontWeight: 600
  }
}))

export default withTranslate(ParentScore)
